module.exports = __webpack_public_path__ + "img/maguirew.4536ab87.jpg";